import React, {Component} from "react";
import FlexView from "react-flexview";
import ModalContainer from "../../../../../modules/commons/ModalContainer";
import SimpleButton from "../../../../../modules/commons/SimpleButton";
import SimpleModal from "../../../../../modules/popup/SimpleModal";
import SimpleDate from "../../../../../modules/SimpleDate";
import SimpleDDL from "../../../../../modules/SimpleDDL";
import SimpleInput from "../../../../../modules/SimpleInput";
import {mapToObjectDDL} from "../../../../common/mapper";
import Api from "../../../../../Services/Api";
import SimpleLoadingOverlay from "../../../../../modules/popup/SimpleLoadingOverlay";
import M from "moment";

class ReceivingUnitNOSFilter extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            data: {},
            dataLocator: [],
            dataVariant: [],
            dataWarna: [],
        };
    }

    componentDidMount = async () => {
        this.handleTriggerLoading();
        await this.fetchDataLocator();
        await this.fetchDataVariant();
        await this.fetchDataWarna();
        this.handleTriggerLoading();
    }

    handleSubmitForm = () => {
        this.props.onSubmit(this.state.data);
    };

    handleTriggerLoading = () => {
        this.setState((prevValue) => ({
            ...prevValue,
            loading: !prevValue.loading,
        }));
    };

    fetchDataLocator = async () => {
        try {
            let res = await Api.create("NAGAMAS_MASTER_DATA").getAllMasterLocationPagingByParam({
                paramFilters: {kodeCabang: this.props.selectedCabang?.value},
                page: null,
                limit: null
            })

            if (res.ok) {
                this.setState((prevState) => ({
                    ...prevState,
                    dataLocator: res.data.data
                }));
            }

        } catch (error) {
            console.log("errors: ", error);
        }
    }

    fetchDataVariant = async () => {
        try {
            let response = await Api.create("NAGAMAS_MASTER_DATA").getAllVariant();
            if (response.ok) {
                this.setState((prevState) => ({
                    ...prevState,
                    dataVariant: response.data.data
                }));
            }
        } catch (error) {
            console.log("errors: ", error);
        }
    };

    fetchDataWarna = async () => {
        try {
            let response = await Api.create("NAGAMAS_MASTER_DATA").getAllWarna();
            if (response.ok) {
                this.setState((prevState) => ({
                    ...prevState,
                    dataWarna: response.data.data,
                }));
            }
        } catch (error) {
            console.log("errors: ", error);
        }
    }

    render() {
        return (
            <SimpleModal
                title="Filter Search"
                visible={this.props.visible}
                onClickClose={() => this.props.onClickClose()}
                content={
                    <ModalContainer>
                            <FlexView column>
                                <FlexView column vAlignContent="center">
                                    <p>Tanggal SPBM:</p>
                                    <FlexView vAlignContent="center" style={{gap: "10px"}}>
                                        <SimpleDate
                                            nextdate
                                            maxDate={new Date()}
                                            date={this.props.selectedData.startDateSPBM}
                                            onChange={(value) =>
                                                this.props.onValueChange("startDateSPBM", M(value).format("DD-MM-YYYY"))
                                            }
                                        />
                                        <span className="margin-bottom-20px">To</span>
                                        <SimpleDate
                                            date={this.props.selectedData.endDateSPBM}
                                            onChange={(value) =>
                                                this.props.onValueChange("endDateSPBM", M(value).format("DD-MM-YYYY"))
                                            }
                                        />
                                    </FlexView>
                                </FlexView>
                                <SimpleInput
                                    id="input_text_no_spbm"
                                    name="spbmNo"
                                    label="No. SPBM"
                                    value={this.props.selectedData.spbmNo}
                                    onChange={({target}) =>
                                        this.props.onValueChange(target.name, target.value?.trim())
                                    }
                                />
                                <FlexView column vAlignContent="center">
                                    <p>Tanggal SL:</p>
                                    <FlexView vAlignContent="center" style={{gap: "10px"}}>
                                        <SimpleDate
                                            date={this.props.selectedData.startDateSL}
                                            onChange={(value) =>
                                                this.props.onValueChange("startDateSL", M(value).format("DD-MM-YYYY"))
                                            }
                                        />
                                        <span className="margin-bottom-20px">To</span>
                                        <SimpleDate
                                            date={this.props.selectedData.endDateSL}
                                            onChange={(value) =>
                                                this.props.onValueChange("endDateSL", M(value).format("DD-MM-YYYY"))
                                            }
                                        />
                                    </FlexView>
                                </FlexView>
                                <SimpleInput
                                    id="input_text_no_shipping_list"
                                    name="slNo"
                                    label="No. Shipping List (SL)"
                                    value={this.props.selectedData.slNo}
                                    onChange={({target}) =>
                                        this.props.onValueChange(target.name, target.value?.trim())
                                    }
                                />
                                <SimpleDDL
                                    id="select_options_manual"
                                    box="search"
                                    name="manual"
                                    label="Manual?"
                                    isClearable={true}
                                    options={[{label: "YES", value: true}, {label: "NO", value: false}]}
                                    value={this.props.selectedData.manual}
                                    onChange={(value, {name}) => this.props.onValueChange(name, value)}
                                />
                                <h3>Filter Detail</h3>
                                <SimpleDDL
                                    id={`select_options_kode_varian`}
                                    box="search"
                                    name="variantCode"
                                    label="Kode Varian"
                                    isClearable={true}
                                    options={this.state.dataVariant.map(
                                        item => mapToObjectDDL(
                                            item.kodeVariant,
                                            item.kodeVariant
                                        ))}
                                    value={this.props.selectedData.variantCode}
                                    onChange={(value, {name}) => this.props.onValueChange(name, value)}
                                />
                                <SimpleInput
                                    id="input_text_no_rangka"
                                    name="frameCode"
                                    label="No. Rangka"
                                    value={this.props.selectedData.frameCode}
                                    onChange={({target}) =>
                                        this.props.onValueChange(target.name, target.value?.trim())
                                    }
                                />
                                <SimpleInput
                                    id="input_text_no_mesin"
                                    name="machineCode"
                                    label="No. Mesin"
                                    value={this.props.selectedData.machineCode}
                                    onChange={({target}) =>
                                        this.props.onValueChange(target.name, target.value?.trim())
                                    }
                                />
                                <SimpleDDL
                                    id={`select_options_kode_warna`}
                                    box="search"
                                    name="colorCode"
                                    label="Warna"
                                    isClearable={true}
                                    options={this.state.dataWarna.map(
                                        item => mapToObjectDDL(
                                            item.namaWarnaPabrik,
                                            item.id
                                        ))}
                                    value={this.props.selectedData.colorCode}
                                    onChange={(value, {name}) => this.props.onValueChange(name, value)}
                                />
                                <SimpleDDL
                                    id="select_options_status_rfs"
                                    box="search"
                                    name="rfsStatus"
                                    label="Status RFS"
                                    isClearable={true}
                                    options={[{label: "YES", value: true}, {label: "NO", value: false}]}
                                    value={this.props.selectedData.rfsStatus}
                                    onChange={(value, {name}) => this.props.onValueChange(name, value)}
                                />
                                <SimpleInput
                                    id="input_text_thn_produksi"
                                    name="yearManufactured"
                                    label="Thn. Produksi"
                                    box="onlyNumber"
                                    value={this.props.selectedData.yearManufactured}
                                    onChange={({target}) =>
                                        this.props.onValueChange(target.name, target.value)
                                    }
                                />
                                <SimpleDDL
                                    id="select_options_locator"
                                    box="search"
                                    name="locatorCode"
                                    label="Locator"
                                    isClearable={true}
                                    options={this.state.dataLocator ? this.state.dataLocator.map(
                                        item => mapToObjectDDL(
                                            item.nameLocation,
                                            item.kodeLocation
                                        )) : []}
                                    value={this.props.selectedData.locatorCode}
                                    onChange={(value, {name}) => this.props.onValueChange(name, value)}
                                />
                            </FlexView>
                            <FlexView hAlignContent="right" style={{gap: "10px"}}>
                                <SimpleButton
                                    secondary
                                    type="button"
                                    text={"Clear"}
                                    onClick={this.props.onClearForm}
                                />
                                <SimpleButton
                                    onClick={this.handleSubmitForm}
                                    text={"Terapkan"}
                                />
                            </FlexView>

                        <SimpleLoadingOverlay active={this.state.loading}/>
                    </ModalContainer>
                }
            />
        );
    }
}

export default ReceivingUnitNOSFilter;
